<template>

  <div>
    <nav id="main-header" class="navbar navbar-expand-md fixed-top navbar-dark py-3 px-3 px-md-5 justify-content-between flex-nowrap bg-white" :class="{ mobileActive: navbarMobileVisible }">
      <button class="hamburger hamburger--slider navbar-toggle mr-3 d-lg-none d-xm-block" :class="{ 'is-active': navbarMobileVisible }" type="button" @click="toggleMenu">
        <span class="hamburger-box">
          <span class="hamburger-inner"></span>
        </span>
      </button>

      <router-link to="/" class="navbar-brand m-0 mr-auto">
        <img src="@/assets/images/logo.png" alt="Talentos na Pista Logotipo">
      </router-link>

      <div class="d-flex">
        <ul class="navbar-nav navbar-mobile">
          <span class="navbar-mobile-bg" @click="toggleMenu"></span>

          <li class="nav-item" @click="toggleMenu"> <router-link to="/vagas" class="nav-link">Vagas</router-link> </li>

          <li class="nav-item" @click="toggleMenu"> <router-link to="/meu-perfil" class="nav-link">Perfil</router-link> </li>

          <li class="nav-item" @click="toggleMenu"> <router-link to="/#sobre" class="nav-link">Sobre</router-link> </li>

          <li class="nav-item" @click="toggleMenu">
            <router-link :to="`/banco-de-talentos/${$store.state.bancoDeTalentos}/inscricao`" class="btn btn-wl-primary rounded-xl px-5 py-2" :class="[ enrolledBancoDeTalentos ? 'disabled' : '' ]">
            {{ enrolledBancoDeTalentos ? "Você já está inscrito" : "Deixe seu currículo" }}
            </router-link>
          </li>
        </ul>
      </div>

    </nav>
  </div>

</template>

<script>
  import FullColor from '@/components/FullColor.vue'
  import MagnifyIcon from "vue-material-design-icons/Magnify.vue"

  export default {
    name: 'MainHeader',

    data(){
      return {
        headerBackground: false,
        navbarMobileVisible: false,
        heroSection: null
      }
    },

    computed: {
      firstName() {
        if(this.$store.state.user){
          const profile = this.$store.state.user.profile;
          const socialName = profile.socialName;
          const name = profile.name.split(' ')[0];
          if(socialName){
            return socialName;
          } else if(window.signUp){
            return null
          } else if(name){
            return name;
          }
        }

        return null;
      },

      enrolledBancoDeTalentos() {
        return !!this.$store.state.opportunities.subscriptions.find(
          (subs) => subs.opportunityId == process.env.VUE_APP_BANCO_DE_TALENTOS
        );
      },
    },

    components: {
      FullColor,
      MagnifyIcon
    },

    methods: {
      handleScroll (event) {
        let scrolledAfter = this.heroSection ? this.heroSection.offsetHeight - 110 : -1;
        let scrollY = window.scrollY || window.pageYOffset;

        if( scrollY > scrolledAfter ){
          this.headerBackground = true;
        }else{
          this.headerBackground = false;
        }
      },

      toggleMenu(){
        this.navbarMobileVisible = !this.navbarMobileVisible;
        const intercomBtn = document.querySelector('.intercom-launcher-frame');
        if(intercomBtn){
          if(this.navbarMobileVisible){
            intercomBtn.classList.add('show')
          }else{
            intercomBtn.classList.remove('show')
          }
        }
      },

      signOut(){
        this.$store.dispatch('user/signOut')
        if( this.$route.meta.requiresAuth ) this.$router.push('/')
      },

      changeModal(target){
        this.$store.commit('DEVISE_FORM', target);
      }
    },

    mounted () {
      this.heroSection = document.querySelector('.hero');
      this.handleScroll();
      window.addEventListener('scroll', this.handleScroll);
    },

    destroyed () {
      window.removeEventListener('scroll', this.handleScroll);
    },

    watch:{
      $route (to, from){
        this.heroSection = document.querySelector('.hero');
        this.handleScroll();
      }
    }
  }
</script>

<style lang="scss" scoped>
  .navbar{
    .navbar-brand{
      width: 250px;
      max-width: 250px;

      img{
        display: block;
        max-height: 40px;
      }
    }

    .nav-item{
      display: flex;
      align-items: center;
      margin: 0 0 0 20px;

      .nav-link{
        font-size: 18px;
        color: #000000;
        width: 100%;
        padding: 0 1.3rem;

        &:hover, &:active, &:focus{
          color: theme-color-level(wl-primary, 2);
        }

        @include media-breakpoint-up(lg){
          text-align: center;
        }
      }

      .btn{
        font-size: 18px;
      }

      &:last-of-type{
        .nav-link{
          padding-right: 0;
        }
      }
    }

    &.mobileActive{
      .navbar-mobile{
        transform: translateX(0vw);

        .navbar-mobile-bg{
          opacity: 1;
          visibility: visible;
        }
      }
    }

    .navbar-mobile{
      .navbar-mobile-bg{
        display: none;
      }

      @include media-breakpoint-down(md){
        width: 290px;
        position: fixed;
        left: 0;
        top: 0;
        height: 100%;
        background: #fff;
        z-index: 10;
        transform: translateX(-100vw);
        transition: transform 0.3s ease-in-out;
        flex-direction: column !important;

        .nav-item{
          width: 100%;
          margin: 0 0 0 0;
          padding: 10px;

          &.active{
            .nav-link{
              background-color: theme-color('light-dark')  !important;
              border-bottom: none !important;
            }
          }

          .nav-link{
            color: $body-color  !important;
            padding: 1rem !important;
            font-weight: 400 !important;
            text-transform: capitalize !important;
            &:hover{
              background-color: theme-color('light-dark') !important;
            }
          }
        }

        .navbar-mobile-bg{
          display: block;
          width: 200vw;
          height: 100%;
          position: fixed;
          left: 290px;
          right: 0;
          background: rgba(0, 0, 0, 0.5);
          opacity: 0;
          visibility: hidden;
          transition: opacity 0.2s ease-in-out .1s, visibility .01s linear;
        }
      }
    }
  }
</style>